export class InitLocalCacheLookup {
  static readonly type = '[Lookup] InitLocalCacheLookup';
}

export class LoadCacheLookup {
  static readonly type = '[Lookup] LoadCache';
}
